import copy from '../_content/site-copy.json'
export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span
      className={`museum-wordmark ${className}`}
      aria-label={copy.site.name}
    >
      {copy.site.wordmark.map((word) => (
        <span key={word} aria-hidden="true">
          {word}
        </span>
      ))}
    </span>
  )
}
